<div id="modal">
    <div class="title flex gap_10 f_align_c">
        {{'fingerprints' | translate}}
    </div>
    <!-- TODO: refine default width and height with Marque 5.1 largest image for all three inputs -->
    <canvas #previewCanvas width="640" height="480" mat-dialog-content></canvas>
    <form #presentFingersTable style="width: 100%" mat-dialog-content>
        <table style="width: 100%">
            <thead>
                <tr>
                    <th><i>{{'fingers.missing' | translate}}</i></th>
                    <th>{{'finger.thumb' | translate}}</th>
                    <th>{{'finger.index' | translate}}</th>
                    <th>{{'finger.middle' | translate}}</th>
                    <th>{{'finger.ring' | translate}}</th>
                    <th>{{'finger.little' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>{{'hand.left' | translate}}</th>
                    <td><input type="checkbox" [checked]="presentFingers[left.thumb]" (change)="presentFingers[left.thumb] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[left.index]" (change)="presentFingers[left.index] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[left.middle]" (change)="presentFingers[left.middle] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[left.ring]" (change)="presentFingers[left.ring] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[left.little]" (change)="presentFingers[left.little] = $event.target.checked" /></td>
                </tr>
                <tr>
                    <th>{{'hand.right' | translate}}</th>
                    <td><input type="checkbox" [checked]="presentFingers[right.thumb]" (change)="presentFingers[right.thumb] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[right.index]" (change)="presentFingers[right.index] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[right.middle]" (change)="presentFingers[right.middle] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[right.ring]" (change)="presentFingers[right.ring] = $event.target.checked" /></td>
                    <td><input type="checkbox" [checked]="presentFingers[right.little]" (change)="presentFingers[right.little] = $event.target.checked" /></td>
                </tr>
            </tbody>
        </table>
    </form>
    <div mat-dialog-actions>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onLeftHandClick()"
            [disabled]="isInCapture() || checkLeftHand()">
            {{'hand.left' | translate}}
        </app-button>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onThumbsClick()"
            [disabled]="isInCapture() || checkThumbs()">
            {{'finger.thumbs' | translate}}
        </app-button>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onRightHandClick()"
            [disabled]="isInCapture() || checkRightHand()">
            {{'hand.right' | translate}}
        </app-button>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onCancelClick()"
            [disabled]="isInCapture()">
            {{'global.cancel' | translate}}
        </app-button>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onValidateClick()"
            [disabled]="isInCapture() || !canValidate()">
            {{'global.validate' | translate}}
        </app-button>
    </div>
</div>
